import { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const UserContext = createContext('');

export function UserProvider({ children }) {
  const [username, setUsername] = useState();

  const value = useMemo(() => ({
    username, setUsername,
  }), [username]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
